//Serviços
import { Axios } from "../../service/serviceBasic";
import {
  converterListActionForListReduceDropdownDadosComplementaresEstadoCivil,
  converterListActionForListReduceDropdownDadosComplementaresGenero,
} from "../../helper/converter";

//Tipos
import {
  SET_DADOS_COMPLEMENTARES_ESTADO_CIVIL,
  LOADING_DADOS_COMPLEMENTARES_ESTADO_CIVIL,
  ERROR_DADOS_COMPLEMENTARES_ESTADO_CIVIL,
  SET_DADOS_COMPLEMENTARES_GENERO,
  LOADING_DADOS_COMPLEMENTARES_GENERO,
  ERROR_DADOS_COMPLEMENTARES_GENERO,
  SET_DADOS_COMPLEMENTARES_PAIS,
  LOADING_DADOS_COMPLEMENTARES_PAIS,
  ERROR_DADOS_COMPLEMENTARES_PAIS,
  CHANGE_DADOS_COMPLEMENTARES_VALUE_FORM,
  HANDLE_CHANGE_DADOS_GENERO,
  HANDLE_CHANGE_DADOS_ESTADO_CIVIL,
  HANDLE_CHANGE_DADOS_FLAG_DOMICIO_FISCAL,
  HANDLE_CHANGE_DADOS_FLAG_PESSOA_AMERICANA,
  HANDLE_CHANGE_TYPEAHEAD,
} from "./types";

const loadingListDadosComplementaresEstadoCivilAction = (flag) => ({
  type: LOADING_DADOS_COMPLEMENTARES_ESTADO_CIVIL,
  payload: flag,
});
const setListDadosComplementaresEstadoCivilAction = (list) => ({
  type: SET_DADOS_COMPLEMENTARES_ESTADO_CIVIL,
  payload: list,
});
const setErrorListDadosComplementaresEstadoCivil = (message) => ({
  type: ERROR_DADOS_COMPLEMENTARES_ESTADO_CIVIL,
  payload: message,
});

export const getListDadosComplementaresEstadoCivilAction = () => (dispatch) => {
  dispatch(loadingListDadosComplementaresEstadoCivilAction(true));
  return Axios.post("v1/basico/estadocivil/list", {})
    .then((response) => {
      let listResponse = converterListActionForListReduceDropdownDadosComplementaresEstadoCivil(
        response.data
      );

      dispatch(setListDadosComplementaresEstadoCivilAction(listResponse));
    })
    .catch((error) => {
      dispatch(setErrorListDadosComplementaresEstadoCivil(error.message));
    })
    .finally(() => {
      dispatch(loadingListDadosComplementaresEstadoCivilAction(false));
    });
};

const loadingListDadosComplementaresGeneroAction = (flag) => ({
  type: LOADING_DADOS_COMPLEMENTARES_GENERO,
  payload: flag,
});
const setListDadosComplementaresGeneroAction = (list) => ({
  type: SET_DADOS_COMPLEMENTARES_GENERO,
  payload: list,
});
const setErrorListDadosComplementaresGenero = (message) => ({
  type: ERROR_DADOS_COMPLEMENTARES_GENERO,
  payload: message,
});

export const getListDadosComplementaresGeneroAction = () => (dispatch) => {
  dispatch(loadingListDadosComplementaresGeneroAction(true));
  return Axios.post("v1/basico/genero/list", {})
    .then((response) => {
      let listResponse = converterListActionForListReduceDropdownDadosComplementaresGenero(
        response.data
      );

      dispatch(setListDadosComplementaresGeneroAction(listResponse));
    })
    .catch((error) => {
      dispatch(setErrorListDadosComplementaresGenero(error.message));
    })
    .finally(() => {
      dispatch(loadingListDadosComplementaresGeneroAction(false));
    });
};

const loadingListDadosComplementaresPaisAction = (flag) => ({
  type: LOADING_DADOS_COMPLEMENTARES_PAIS,
  payload: flag,
});
const setListDadosComplementaresPaisAction = (list) => ({
  type: SET_DADOS_COMPLEMENTARES_PAIS,
  payload: list,
});
const setErrorListDadosComplementaresPais = (message) => ({
  type: ERROR_DADOS_COMPLEMENTARES_PAIS,
  payload: message,
});

export const getListDadosComplementaresPaisAction = () => (dispatch) => {
  dispatch(loadingListDadosComplementaresPaisAction(true));
  return Axios.post("v1/basico/pais/list", {})
    .then((response) => {
      dispatch(setListDadosComplementaresPaisAction(response.data));
    })
    .catch((error) => {
      dispatch(setErrorListDadosComplementaresPais(error.message));
    })
    .finally(() => {
      dispatch(loadingListDadosComplementaresPaisAction(false));
    });
};

export const changeDadosComplementaresValueForm = (name, value) => (
  dispatch,
  getState
) => {
  let { dadosComplementaresReducer } = getState();
  let formDados = dadosComplementaresReducer.formDados;

  formDados[name] = value;

  dispatch({
    type: CHANGE_DADOS_COMPLEMENTARES_VALUE_FORM,
    payload: formDados,
  });
};

// export const handleChangeDadosGenero = event => (dispatch, getState) => {

//   let obj = {}

//   dispatch({
//     type: CHANGE_DADOS_COMPLEMENTARES_VALUE_FORM,
//     payload: formDados
//   })
// }

export const handleChangeDadosGenero = (event) => ({
  type: HANDLE_CHANGE_DADOS_GENERO,
  payload: event.value,
});

export const handleChangeDadosEstadoCivil = (event) => ({
  type: HANDLE_CHANGE_DADOS_ESTADO_CIVIL,
  payload: event.value,
});

export const handleChangeDadosFlagDomicilioFiscal = (event) => ({
  type: HANDLE_CHANGE_DADOS_FLAG_DOMICIO_FISCAL,
  payload: event.value,
});

export const handleChangeDadosFlagPessoaAmericana = (event) => ({
  type: HANDLE_CHANGE_DADOS_FLAG_PESSOA_AMERICANA,
  payload: event.value,
});

export const handleChangeTypeahead = (data) => ({
  type: HANDLE_CHANGE_TYPEAHEAD,
  payload: data,
});
